<template>
	<el-dialog title="添加达人账号" :visible.sync="visible" width="540px" :before-close="beforeClose" :close-on-click-modal="false">
		<Tip type="warning" content="仅支持选择团队公海内的达人" class="fz-14"> </Tip>
		<div class="yx-background radius-8 p-16 mt-24">
			<el-form label-width="90px">
				<el-form-item label="达人账号">
					<anchor-select
						ref="anchorSelect"
						v-model="anchorUids"
						:platformId="platformId"
						returnType="anchor_uid"
						class="width100"
						:multipleLimit="100"
					></anchor-select>
				</el-form-item>
			</el-form>

			<p
				class="yx-color-primary font-h4-regular mt-12 text-align-right cursor-pointer"
				v-if="$auth.hasPermi('system:talnetContacts:add-edit')"
				@click="addNewFun"
				>没找到？请联系达人商务添加达人</p
			>
		</div>
		<div slot="footer">
			<el-button @click="beforeClose">取消</el-button>
			<el-button type="primary" @click="confirm">添加</el-button>
		</div>
	</el-dialog>
</template>
<script>
import AnchorSelect from '@/modules/anchor/select';
import { investmentAnchorKs } from '@/api/secondColonelManage';
export default {
	components: {
		AnchorSelect,
	},
	data() {
		return {
			visible: false,
			platformId: +dataMap.PLATFORM_KS.value,
			anchorUids: '',
			thirdActivityId: '',
			authorityId: '',
		};
	},
	methods: {
		show(thirdActivityId, authorityId) {
			this.thirdActivityId = thirdActivityId;
			this.authorityId = authorityId;
			this.visible = true;
		},
		async confirm() {
			const { anchorUids, platformId, authorityId, thirdActivityId } = this;
			await investmentAnchorKs({ platformId, anchorUids, operatorType: 1, authorityId, thirdActivityId });
			this.$emit('refresh', 1);
			this.$message.success('操作成功');
			this.beforeClose();
		},
		addNewFun() {
			const handLink = this.$router.resolve({
				path: '/talentCRM',
				query: { platformId: this.platformId },
			});
			window.open(handLink.href, '_blank');
		},
		beforeClose() {
			this.thirdActivityId = '';
			this.authorityId = '';
			this.anchorUids = '';
			this.$refs.anchorSelect.reset();
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped>
</style>